import { isDateGobdCompliant } from "@finway-group/shared/lib/utils"
import { Rule } from "antd/lib/form"
import i18n from "~Shared/locales/i18n"

export const dateRules = {
    gobdCompliant: {
        validator: (_rule, value: Date) => {
            if (value && !isDateGobdCompliant(value)) {
                return Promise.reject(new Error(i18n.t("validation:out_of_range.date")))
            }

            return Promise.resolve()
        },
    } as Rule,
}
